import React from 'react';
import { ADNewLogo } from './styles';
import { HOSTNAME } from '@/constants/constantsAckoDrive';

export interface ILogo {
    LogoSvg: any;
    margin?: string;
    width: string;
    height: string;
    flexShrink?: string;
}

export default function Logo({
    LogoSvg,
    margin,
    width,
    height,
    flexShrink,
}: ILogo) {
    const handleClick = (e: any) => {
        e.preventDefault();
        window.location.href = HOSTNAME + '/';
    };

    return (
        <ADNewLogo
            marginValue={margin}
            widthValue={width}
            heightValue={height}
            flexShrinkValue={flexShrink}
            onClick={handleClick}
            href="https://ackodrive.com/"
        >
            <img src={LogoSvg} alt="Acko Drive Logo" />
        </ADNewLogo>
    );
}
